module.exports = __webpack_public_path__ + "img/heart.ecd41865.png";